(function () {
  var loading;
  function banner() { return window.privacyBanner || (window.Shopify && window.Shopify.privacyBanner); }
  function loadBanner() {
    if (banner()) return Promise.resolve(banner());
    if (!loading) loading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      script.onload = function () { banner() ? resolve(banner()) : reject(new Error('Banner non disponibile')); };
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch(function (error) { loading = null; throw error; });
    return loading;
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mb-cookie-preferences]');
    if (!button) return;
    button.disabled = true;
    loadBanner().then(function (api) { return api.showPreferences(); }).catch(function () {
      var message = document.createElement('span');
      message.setAttribute('role', 'status');
      message.textContent = document.documentElement.lang === 'en' ? 'Preferences are unavailable. Reload the page and try again.' : 'Preferenze non disponibili. Riprova dopo aver ricaricato la pagina.';
      button.after(message);
    }).finally(function () { button.disabled = false; });
  });
})();
